import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'



// firebase init
const firebaseConfig = {
    apiKey: "AIzaSyApBx0mXU92LQsetSCsXophdYBn1-Zc0Ak",
    authDomain: "cementoschihuahuaraspaygana.firebaseapp.com",
    projectId: "cementoschihuahuaraspaygana",
    storageBucket: "cementoschihuahuaraspaygana.appspot.com",
    messagingSenderId: "716760318215",
    appId: "1:716760318215:web:8e1b9fcc4cd7b4c4ea85a2"
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
const functions = firebase.functions()

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')
const ticketsCollection = db.collection('tickets')

// export utils/refs
export {
    db,
    auth,
    storage,
    functions,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection,
    ticketsCollection
}